// A shareable link to a task points at its list with the task pre-selected —
// the same deep-link the Android widget uses (Lists/Show and MyDay/Show read `?task=<id>`).
// A task always lives in a list (subtasks inherit their root's list), so `listId`
// is present for both top-level tasks and drilled-in subtasks.
export function taskPath(listId: string, taskId: string): string {
  return `/lists/${listId}?task=${taskId}`;
}

export function taskUrl(listId: string, taskId: string): string {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}${taskPath(listId, taskId)}`;
}

// Stripped from the address bar so a reload doesn't pop the same panel again.
export function consumeTaskDeepLink(): string | null {
  const params = new URLSearchParams(window.location.search);
  const taskId = params.get("task");
  if (!taskId) return null;
  params.delete("task");
  const qs = params.toString();
  window.history.replaceState(null, "", window.location.pathname + (qs ? `?${qs}` : ""));
  return taskId;
}
